module.exports = __webpack_public_path__ + "static/media/ElProspectorCL.b8adbcdd.png";